import { useSelector } from 'react-redux';

export default function GlobalLoader() {
  const loaderState = useSelector((state) => state.loader);

  const isLoading = Object.values(loaderState).some((val) => val);

  if (!isLoading) return null;

  return (
    <div className="loader_main">
      <div className="loader-inner ball-scale-multiple">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
